<wim-assignment [assignments]="qualificationAssignments"
                [title]="'QUALIFICATIONS'"
                (updatedAssignment)="updateAssignment($event)">
</wim-assignment>
